import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { 
  HiOutlineTicket, HiOutlineChevronDown, HiOutlineChevronUp, 
  HiOutlineCheckCircle, HiOutlineXCircle, HiOutlineClock, 
  HiOutlineWallet, HiOutlineUser, HiOutlineBuildingOffice2, HiOutlineMapPin,
  HiOutlineXMark, // Added for cancel icon
  HiOutlineSparkles
} from "react-icons/hi2";
import { baseurl } from "../baseurl"; 

const AllBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState(null);
  const [isCancelling, setIsCancelling] = useState(null); // Track which ID is being cancelled
  const navigate = useNavigate();
  const guestUserId = localStorage.getItem('guestUserId');

  const fetchBookings = async () => {
    try {
      const response = await axios.get(`${baseurl}/getUserBookings/${guestUserId}`);
      if (response.data.status === "success") setBookings(response.data.bookings);
    } catch (error) {
      console.error("Error:", error);
    } finally { setLoading(false); }
  };

  useEffect(() => {
    if (guestUserId) fetchBookings();
  }, [guestUserId]);

  const toggleDetails = (id) => setExpandedId(expandedId === id ? null : id);

  const formatDate = (ds) => new Date(ds).toLocaleDateString('en-IN', { 
    day: '2-digit', month: 'short', year: 'numeric' 
  });

  // New Cancellation Handler
  const handleCancel = async (booking) => {
    if (!window.confirm(`Are you sure you want to cancel this ${booking.service_type.toLowerCase()} booking?`)) return;
    
    setIsCancelling(booking.id);
    try {
      const endpoint = booking.service_type === "HOTEL" 
        ? `${baseurl}cancelHotelBooking` 
        : `${baseurl}cancelBusTicketGuest`;

      console.log("bookingId", booking.id);


      console.log("reference", booking.booking_reference);



      const response = await axios.post(endpoint, {
        bookingId: booking.id,
        reference: booking.booking_reference,
        // Add any other required payload fields here
      });

      console.log("response", response);

      if (response.data.status === "success") {
        alert("Booking cancelled successfully.");
        fetchBookings(); // Refresh the list
      } else {
        alert(response.data.message || "Cancellation failed. Please contact support.");
      }
    } catch (error) {
      console.error("Cancellation error:", error);
      alert("Error processing cancellation.");
    } finally {
      setIsCancelling(null);
    }
  };

const handleViewInvoice = (booking) => {
// 1. It checks if response_payload is a string
const ref = booking.booking_reference || booking.id; 

  console.log("booking", booking); 

// 3. IF service is BUS and 'tin' exists, navigate...
  if (booking.service_type === "BUS" && ref) {
    navigate(`/bus-invoice/${ref}`);
  }
  else if (booking.service_type === "HOTEL" && ref) {
    navigate(`/hotel-invoice/${ref}`);
  } 
  // Add Electricity Logic here
  else if (booking.service_type === "ELECTRICITY" && ref) {
    navigate(`/electricity-invoice/${ref}`);
  }


  else if (booking.service_type === "FLIGHT" && ref) {
    navigate(`/flightinvoice/${ref}`);
  }



  else {
    alert("Invoice details are still being processed.");
  }
};

 
  const handleLogout = () => { 
  localStorage.clear(); 
  navigate("/"); 
  window.location.reload(); 
  };


  if (loading) return (
    <div className="d-flex flex-column justify-content-center align-items-center min-vh-100 bg-light">
      <div className="spinner-grow text-primary mb-3" role="status"></div>
      <h6 className="fw-bold text-muted text-uppercase letter-spacing-2">Syncing your trips...</h6>
    </div>
  );

  return (
    <div className="container-fluid py-4 px-3" style={{ backgroundColor: '#f4f7f6', minHeight: '100vh' }}>
      
      {/* Redesigned Mobile Nav */}
      <div className="mobile-nav-wrapper mb-4 shadow-sm rounded-4 overflow-hidden">
        <div className="mobile-nav-container py-3">
          <Link to="/profile" className="mobile-nav-link">
            <HiOutlineUser className="nav-icon" />
            <span>Profile</span>
          </Link>
          <Link to="/wallet" className="mobile-nav-link">
            <HiOutlineWallet className="nav-icon" />
            <span>Pocket</span>
          </Link>
          <Link to="/booking" className="mobile-nav-link active">
            <HiOutlineTicket className="nav-icon" />
            <span>Trips</span>
          </Link>

    <Link  className="mobile-nav-link" onClick={handleLogout}>
          <HiOutlineSparkles className="nav-icon" />
          <span>Logout</span>
        </Link>



        </div>
      </div>

      <style>
        {`
          .letter-spacing-1 { letter-spacing: 1px; }
          .letter-spacing-2 { letter-spacing: 2px; }
          .bg-teal-gradient { background: linear-gradient(135deg, #166070 0%, #2a91a8 100%); }
          .text-teal { color: #166070; }
          .btn-teal { background: #166070; color: white; border: none; transition: all 0.3s; }
          .btn-teal:hover { background: #0e4450; color: white; transform: translateY(-2px); }
          
          .booking-card {
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            border: 1px solid rgba(0,0,0,0.05) !important;
          }
          .booking-card:hover { transform: scale(1.01); }

          /* Mobile Nav Styles */
          .mobile-nav-wrapper { background: white; border: 1px solid rgba(0,0,0,0.05); }
          .mobile-nav-container { display: flex; justify-content: space-around; }
          .mobile-nav-link { text-decoration: none; color: #94a3b8; text-align: center; }
          .mobile-nav-link.active { color: #166070; }
          .nav-icon { font-size: 22px; margin-bottom: 4px; }
          .mobile-nav-link span { font-size: 10px; font-weight: 700; text-transform: uppercase; }
          .mobile-nav-link.active .nav-icon { color: #166070; }

          @media (min-width: 769px) { .mobile-nav-wrapper { display: none; } }
        `}
      </style>

      {/* Page Header */}
      <div className="mb-4 d-flex justify-content-between align-items-end">
        <div>
          <h3 className="fw-bold mb-0 text-dark">My Journeys</h3>
          <p className="text-muted small mb-0">Track and manage your recent bookings</p>
        </div>
        <div className="text-end d-none d-md-block">
          <span className="badge bg-white text-dark shadow-sm border px-3 py-2 rounded-pill">
            {bookings.length} Total Bookings
          </span>
        </div>
      </div>

      {/* Booking List */}
      <div className="row g-3 justify-content-center">
        {bookings.length === 0 ? (
          <div className="col-12 text-center py-5">
            <div className="p-5 bg-white rounded-5 shadow-sm">
              <HiOutlineTicket size={60} className="text-light mb-3" />
              <h5 className="fw-bold">No bookings yet!</h5>
              <p className="text-muted">Start your next adventure today.</p>
              <Link to="/" className="btn btn-teal px-4 rounded-pill">Book Now</Link>
            </div>
          </div>
        ) : (
          bookings.map((b) => (
            <div className="col-lg-8 col-12" key={b.id}>
              <div className="card booking-card shadow-sm rounded-4 overflow-hidden border-0">
                
                {/* Card Header Section */}
                <div className="p-3 bg-white" onClick={() => toggleDetails(b.id)} style={{ cursor: 'pointer' }}>
                  <div className="row align-items-center">
                    <div className="col-auto">
                      <div className={`rounded-circle p-3 ${b.service_type === 'HOTEL' ? 'bg-info-subtle text-info' : 'bg-primary-subtle text-primary'}`}>
                        {b.service_type === 'HOTEL' ? <HiOutlineBuildingOffice2 size={24} /> : <HiOutlineTicket size={24} />}
                      </div>
                    </div>
                    
                    <div className="col ps-0">
                      <div className="d-flex justify-content-between align-items-start">
                        <div>
                          <span className="fw-bold text-dark d-block mb-0 h6">
                            {b.service_type === 'HOTEL' 
                              ? (b.response_payload?.CommitBooking?.BookingDetails?.HotelName || 'Hotel Booking')
                              : `Trip to ${b.response_payload?.destinationCity || 'Dest.'}`
                            }
                          </span>
                          <span className="text-muted small letter-spacing-1">Ref: {b.booking_reference}</span> <br/>
                          <span className="text-muted small letter-spacing-1">Booking Type: {b.service_type}</span>
                        </div>
                        <div className="text-end">
                          <h5 className="fw-bold text-dark mb-0">₹{parseFloat(b.amount).toLocaleString()}</h5>
                          {b.status === 'SUCCESS' ? 
                            <span className="badge bg-success-subtle text-success border border-success-subtle rounded-pill small">
                              <HiOutlineCheckCircle className="me-1" /> Confirmed
                            </span> : 
                            <span className="badge bg-danger-subtle text-danger border border-danger-subtle rounded-pill small">
                              <HiOutlineXCircle className="me-1" /> {b.status}
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Date and Toggle Footer */}
                  <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                    <div className="small text-muted d-flex align-items-center">
                      <HiOutlineClock className="me-1" /> 
                      <span className="me-2">{formatDate(b.created_at)}</span>
                    </div>
                    <div className="text-teal small fw-bold text-uppercase letter-spacing-1 d-flex align-items-center">
                      {expandedId === b.id ? 'Hide details' : 'View details'}
                      {expandedId === b.id ? <HiOutlineChevronUp className="ms-1" /> : <HiOutlineChevronDown className="ms-1" />}
                    </div>
                  </div>
                </div>

                {/* Expanded Details Section */}
                {expandedId === b.id && (
                  <div className="bg-light p-4 border-top">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <div className="p-3 bg-white rounded-3 border shadow-sm h-100">
                          <label className="text-muted d-block small fw-bold mb-2">TRAVELER INFO</label>
                          <div className="d-flex align-items-center">
                            <HiOutlineUser className="text-teal me-2" size={18}/>
                            <span className="fw-medium text-dark">
                              {b.additional_data?.RoomDetails?.[0]?.PassengerDetails?.[0]?.FirstName || 'Primary Guest'}
                            </span>
                          </div>
                          <div className="mt-2 d-flex align-items-center small text-muted">
                            <HiOutlineMapPin className="me-2" />
                            <span>{b.service_type === 'HOTEL' ? 'Standard Check-in' : 'Boarding Point details'}</span>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="p-3 bg-white rounded-3 border shadow-sm h-100">
                          <label className="text-muted d-block small fw-bold mb-2">PAYMENT LOG</label>
                          <div className="d-flex justify-content-between mb-1 small">
                            <span>Method:</span>
                            <span className="fw-bold text-capitalize">{b.payment_details?.method || 'Razorpay'}</span>
                          </div>
                          <div className="d-flex justify-content-between small">
                            <span>Order ID:</span>
                            <span className="text-truncate ms-3" style={{ maxWidth: '120px' }}>{b.payment_details?.razorpay_order_id}</span>
                          </div>
                        </div>
                      </div>

                      {/* Action Buttons */}
                      {b.status === 'SUCCESS' && (
                        <div className="col-12">
                          <div className="d-flex gap-2">
                            <button 
  onClick={(e) => {
    e.stopPropagation(); 
    handleViewInvoice(b);
  }} 
  className="btn btn-teal flex-grow-1 py-2 fw-bold rounded-3"
>
  <HiOutlineTicket className="me-2" size={18}/> 
  {b.service_type === 'HOTEL' ? 'Download Voucher' : 
   b.service_type === 'ELECTRICITY' ? 'Download Receipt' : 'Download Ticket'}
</button>
                            
                            {/* CANCELLATION BUTTON */}
                            {/* <button 
                              onClick={(e) => {
                                e.stopPropagation();
                                handleCancel(b);
                              }}
                              disabled={isCancelling === b.id}
                              className="btn btn-outline-danger py-2 fw-bold rounded-3 px-4"
                            >
                              {isCancelling === b.id ? (
                                <span className="spinner-border spinner-border-sm"></span>
                              ) : (
                                <><HiOutlineXMark className="me-1" size={18}/> Cancel</>
                              )}
                            </button> */}

                             <button 
  onClick={(e) => {
    e.stopPropagation(); 
    handleViewInvoice(b);
  }} 
  className="btn btn-outline-danger flex-grow-1 py-2 fw-bold rounded-3"
>
  <HiOutlineTicket className="me-2" size={18}/> 
  {b.service_type === 'HOTEL' ? 'Cancel Voucher' : 
   b.service_type === 'ELECTRICITY' ? 'Cancel Receipt' : 'Cancel Ticket'}
</button>


                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AllBookings;